/* QOWAA FIT — Page CONTACT
   Onglets Particulier (B2C) / Professionnel (B2B) : bascule les panels, désactive les champs
   du panel inactif (pour qu'ils ne soient pas soumis), met à jour le champ caché contact[Type].
   Gate RGPD (submit désactivé tant que la case n'est pas cochée). Reveal au scroll. Deep-link #professionnel. */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function initContact(root) {
    // ----- Reveal -----
    var revs = $all('.scroll-in', root);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (revs.length) {
      if (reduce || !('IntersectionObserver' in window)) { revs.forEach(function (e) { e.classList.add('is-in'); }); }
      else { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }); revs.forEach(function (e) { io.observe(e); }); }
    }

    // ----- Tabs (si le formulaire est présent, pas en état succès) -----
    var tabs = $all('[data-contact-tab]', root);
    var panels = $all('[data-contact-panel]', root);
    if (!tabs.length || !panels.length) return;
    var typeInput = $('[data-contact-type]', root);

    function refreshSubmit(panel) {
      var rgpd = $('[data-contact-rgpd]', panel);
      var submit = $('[data-contact-submit]', panel);
      if (rgpd && submit) submit.disabled = !rgpd.checked;
    }
    function setTab(tab) {
      tabs.forEach(function (b) { var on = b.getAttribute('data-contact-tab') === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-contact-panel') === tab;
        p.hidden = !on;
        $all('input, select, textarea', p).forEach(function (el) { el.disabled = !on; });
        if (on) refreshSubmit(p);
      });
      if (typeInput) typeInput.value = (tab === 'professionnel' ? 'Professionnel' : 'Particulier');
    }

    tabs.forEach(function (b) { b.addEventListener('click', function () { setTab(b.getAttribute('data-contact-tab')); }); });
    panels.forEach(function (p) {
      var rgpd = $('[data-contact-rgpd]', p);
      if (rgpd) rgpd.addEventListener('change', function () { refreshSubmit(p); });
    });

    // état initial : deep-link Pro (#professionnel / #pro / #b2b / #revendeur) sinon particulier
    var h = (window.location.hash || '').toLowerCase();
    var wantsPro = h === '#professionnel' || h === '#pro' || h === '#b2b' || h === '#revendeur';
    setTab(wantsPro ? 'professionnel' : 'particulier');
    if (wantsPro) {
      var formSec = $('.contact-form-sec', root);
      if (formSec) setTimeout(function () { formSec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
  }

  function boot() { $all('[data-qw-contact]').forEach(initContact); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-qw-contact]'); if (r) initContact(r); });
})();
